export default __webpack_public_path__ + "static/media/travelers_handy_sword.168a7842.png";